var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPrev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:next-32-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.49848 3.75001C4.49848 3.5511 4.41947 3.36033 4.27881 3.21968C4.13816 3.07903 3.9474 3.00001 3.74848 3.00001C3.54957 3.00001 3.3588 3.07903 3.21815 3.21968C3.0775 3.36033 2.99848 3.5511 2.99848 3.75001V20.25C2.99848 20.4489 3.0775 20.6397 3.21815 20.7803C3.3588 20.921 3.54957 21 3.74848 21C3.9474 21 4.13816 20.921 4.27881 20.7803C4.41947 20.6397 4.49848 20.4489 4.49848 20.25V3.75001ZM21.0007 4.87801C21.0007 3.37651 19.3237 2.48401 18.078 3.32326L7.57573 10.3973C7.32198 10.5683 7.11396 10.7989 6.96983 11.0689C6.8257 11.3389 6.74984 11.64 6.74888 11.9461C6.74791 12.2521 6.82188 12.5537 6.96431 12.8246C7.10674 13.0955 7.31331 13.3273 7.56598 13.5L18.0682 20.67C19.3132 21.519 21.0007 20.628 21.0007 19.1213V4.87801Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrev);
export default __webpack_public_path__ + "static/media/ic_prev.b39508f444858b33079f5025a07b390a.svg";
export { ForwardRef as ReactComponent };